import { render, staticRenderFns } from "./RichTextInputTinyMceDialog.vue?vue&type=template&id=74b5a157&"
import script from "./RichTextInputTinyMceDialog.vue?vue&type=script&lang=ts&"
export * from "./RichTextInputTinyMceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextInputTinyMceDialog.vue?vue&type=style&index=0&id=74b5a157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports